import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { PromotionTouchPointUserService } from '../../../services/promotion/promotion-touch-point-user.service';
import { UsersService } from './../../../services/user/users.service';
import { TranslateService } from '@ngx-translate/core';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';

@Component({
  selector: 'app-touch-point-user',
  templateUrl: './touch-point-user.component.html',
  styleUrls: ['./touch-point-user.component.css']
})
export class TouchPointUserComponent implements OnInit {

  touchPointsUsersData: {id: number, ochannel_id: number, userId: number, userLogin: string, tpCode: string, tpDescription: string, flg_default?: number, flg_state?: string}[] = [];

  selectFilter = KontableComponent.SelectFilter;
  listStates: Array<{label: string, value: string}> = [];
  initialFilters = [{ key: 'flg_state', value: '0', filterType: 'equals' }];

  touchPoints: any[] = [];
  users: any[] = [];

  displayDialog = false;
  submitted = false;
  dialogMode: 'add' | 'edit' = 'add';
  formData: any = { ochannel_id: null, user_id: null, flg_default: 0 };

  @ViewChild('table') table;

  constructor(
    private touchPointUserSvc: PromotionTouchPointUserService,
    private usersSvc: UsersService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.translateService.get(['common.active', 'common.inactive', 'common.all']).subscribe(tr => {
      this.listStates.push({ label: tr['common.active'], value: '0' });
      this.listStates.push({ label: tr['common.inactive'], value: '1' });
      this.listStates.push({ label: tr['common.all'], value: '' });
    });

    this.usersSvc.getAll().subscribe(res => {
      this.users = res.map(u => ({label: `${u.name} ${u.surname} (${u.login})`, value: u.id}));
    });

    this.loadData();
  }

  loadData() {
    this.touchPointsUsersData = [];
    Observable.zip(
      this.touchPointUserSvc.getTouchPoints(),
      this.touchPointUserSvc.getTouchPointUser()
    ).subscribe(([touchPoints, touchPointsUsers]) => {
      this.touchPoints = touchPoints.map(tp => ({label: `${tp.code} - ${tp.description}`, value: tp.id}));
      const data = [];

      touchPointsUsers.forEach(tpu => {
        touchPoints.forEach(tp => {
          if (Number(tp.id) === Number(tpu.ochannel_id)) {
            data.push({
              id: tpu.id,
              ochannel_id: tpu.ochannel_id,
              userId: tpu.user_id,
              userLogin: null,
              tpCode: tp.code,
              tpDescription: tp.description,
              flg_default: tpu.flg_default == '1' ? 1 : 0,
              flg_state: tpu.flg_state
            });
          }
        });
      });

      const idUsers = Array.from(new Set(data.map(d => d.userId).filter(id => id !== null && id !== undefined)));

      if (idUsers.length === 0) {
        this.touchPointsUsersData = data;
        return;
      }

      // il BE può restituire gli id come float (es. 39.0): confronto numerico
      this.usersSvc.getFiltereIdList(idUsers.join(',')).subscribe(res => {
        const logins = new Map<number, string>();
        res.forEach(r => logins.set(Number(r.id), r.login));
        data.forEach(d => d.userLogin = logins.get(Number(d.userId)) || null);
        // nuovo riferimento: la kontable si aggiorna tramite ngOnChanges su [source]
        this.touchPointsUsersData = data;
      }, () => {
        this.touchPointsUsersData = data;
      });
    })
  }

  showAddDialog() {
    this.dialogMode = 'add';
    this.submitted = false;
    this.formData = { ochannel_id: null, user_id: null, flg_default: 0 };
    this.displayDialog = true;
  }

  showEditDialog(row) {
    this.dialogMode = 'edit';
    this.submitted = false;
    this.formData = {
      id: row.id,
      ochannel_id: row.ochannel_id,
      user_id: row.userId,
      flg_default: 0
    };
    this.displayDialog = true;
  }

  save() {
    this.submitted = true;
    if (!this.formData.ochannel_id || !this.formData.user_id) {
      return;
    }
    const payload: any = {
      ochannel_id: this.formData.ochannel_id,
      user_id: this.formData.user_id,
      flg_default: 0 // KS-7923: checkbox flgDefault nascosta, sempre 0 sia in creazione che in modifica
    };
    if (this.dialogMode === 'add') {
      this.touchPointUserSvc.createTouchPointUser(payload).subscribe(() => {
        this.displayDialog = false;
        this.loadData();
      });
    } else {
      payload.id = this.formData.id;
      this.touchPointUserSvc.editTouchPointUser(payload.id, payload).subscribe(() => {
        this.displayDialog = false;
        this.loadData();
      });
    }
  }

  delete(row) {
    this.touchPointUserSvc.deleteTouchPointUser(row.id).subscribe(() => {
      this.loadData();
    });
  }

  recover(row) {
    this.touchPointUserSvc.recoverTouchPointUser(row.id).subscribe(() => {
      this.loadData();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/promotion/touch-point-user/touch-point-user.component.ts